<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><router-link to="/clue">线索</router-link></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">新建商机</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="add-clue">
            <div class="left-menu">
                <a href="javascript:;">
                    <span>基础信息</span>
                    <a-icon type="right" />
                </a>
            </div>
            <div class="right-content">
                <div class="top-title">
                    基础信息 
                </div>
                <div class="add-content">
                    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">

                        <a-form-item v-for="(item,i) in system_field_list" :key="i" :label="item.name"> 
                             <!-- {{item.field_name}} -->
                            <a-input v-model="labelitem[i]" v-if="item.type=='text'||item.type=='mobile'||item.type=='email'" placeholder="请输入"/>
                            <a-select v-if="item.type=='radio'" @change="handleChange($event,item.field_name)" placeholder="请选择" style="width: 100%">
                                <a-select-option :value="option" v-for="(option,idx) in item.option_arr" :key="idx">
                                    {{option}}
                                </a-select-option>
                            </a-select>

                            <a-select mode="multiple" v-if="item.type=='checkbox'"  @change="handleChange($event,item.field_name)"  placeholder="请选择" style="width: 100%">
                                <a-select-option :value="option" v-for="option in item.option_arr" :key="option">
                                    {{option}}
                                </a-select-option>
                            </a-select>
                            <a-date-picker format="YYYY-MM-DD" v-model="labelitem[i]"  v-if="item.type=='date'||item.type=='datetime'"/>
                            <a-textarea v-model="labelitem[i]" v-if="item.type=='textarea'" placeholder="请输入" :auto-size="{ minRows: 2,maxRows:6}"/>
                        </a-form-item>
     
                    </a-form>

                </div>
               
            </div>
        </div>

        <div class="add-button">
            <a-button icon="close-circle" theme="filled">取消</a-button>
            <a-button icon="check-circle" type="primary" @click="saveclue" theme="filled">保存</a-button>
            <!-- <a-button icon="check-circle" type="primary" theme="filled">保存并创建下一条</a-button> -->
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            fieldlist:"",
            system_field_list:"",
            addresoptions:[],
            labelitem:{customer_key:"",intentional_product:"",transaction_amount:"",expected_deal_date:""},
            labelname:{}

        }
    },
    mounted(){
        // 字段
        this.$axios.get('/api/bussnessfieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:1
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.system_field_list=data2
                for(var j in data2){
                    this.labelname[data2[j].field_name]=""
                    this.labelitem[data2[j].field_name]=""
                }
                // alert(JSON.stringify(this.labelitem))
            }else{
                this.$message.warning(res.data.msg);
            }
        })
    },
    methods:{
         handleChange(event,value){
            this.labelitem[value]=event

        },
        // 保存
        saveclue(){
            // var data2=this.system_field_list

            // for(var i in data2){
            
            //     this.labelname[data2[i].field_name]=this.labelitem[i]
            // }
            // var arr=new URLSearchParams()
            // arr.append('arr',this.labelname)
            this.$axios.post('/api/addbussness',this.labelname,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var id=res.data.data.id
                    this.$message.success(res.data.msg); 
                    this.$router.push({path: '/busdetail',query:{ id:id}});
                }else{
                    this.$message.error(res.data.msg);
                }
            })
           
        },


        date(){

        },
        onPanelChange(value, mode) {

        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/customer/addbusiness.vue